
export default {
  methods: {
    // Check if a string of text matches a barcode format
    // Does NOT guarantee the barcode is valid or exists in the system, just if the format matches
    // Requires the expected types provided, otherwise default barcode prefixes will be used
    isBarcodeFormat(text, expectedPrefixes = []) {
      try {
        let barcode = (text || '').toString()

        if(!expectedPrefixes || expectedPrefixes.length == 0) {
          expectedPrefixes = ['P', 'G', 'GB']   // ProductionPanel, GlassLevel, GlassBlock
        }
        expectedPrefixes = expectedPrefixes.map(prefix => {
          return (prefix || '').trim().toUpperCase()
        })

        barcode = barcode.trim().toUpperCase()
        if(barcode.length <= 1)
          return false

        let matchingPrefix = expectedPrefixes.find(prefix => barcode.startsWith(prefix))
        if(!matchingPrefix)
          return false

        // Rest of the barcode must be numeric
        let remainder = barcode.slice(matchingPrefix.length)
        if(remainder.length > 0) {
          if(remainder.match(/^[0-9]+$/) != null)
            return true
        }

        return false
      } catch(err) {
        console.log(`Error while parsing barcode: ${err}`)
        return false
      }
    }
  }
}
